<template>
  <div style="width: 100%;">
    <v-data-table :headers="headers" :items="serviceCredentials" class="elevation-1 service-credentials" style="width: 100%; font-size: 12px;" :pagination.sync="pagination">
      <template v-slot:items="props">
        <tr class="item-row" :class="{ new: newItems.includes(props.item.RefreshTokenId) }">
          <td class="text-xs-left">{{ props.item.CreatedBy }}</td>
          <td class="text-xs-left">{{ props.item.CreationDateUtc }}</td>
          <td class="center px-0">
            <ConfirmationDialog :loading="isRemoving(props.item)" :small="true" title="Revoke Credential" label="Revoke" text="Are you sure you want to revoke this credential? All Camunda process that use this token must be updated." @submit="remove(props.item)" />
            <v-btn :class="{ hidden: !props.item.RefreshToken }" small dark @click="viewItem(props.item)">
              <v-icon left>search</v-icon>
              {{$t('Button.View')}}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <ViewItemDialog ref="viewItemDialog" :serviceCredential="itemViewed" />
  </div>
</template>

<script>
  import ViewItemDialog from './ViewItem'
  import ConfirmationDialog from '../Helpers/ConfirmationDialog'
  import moment from 'moment'

  export default {
    components: {
      ViewItemDialog,
      ConfirmationDialog,
    },
    props: {
      serviceCredentials: Array,
    },
    data() {
      return {
        headers: [
          { text: 'Created by', value: 'CreatedBy' },
          { text: 'Creation Date (UTC)', value: 'CreationDateUtc' },
          { text: 'Actions', value: 'name', sortable: false },
        ],
        itemViewed: null,
        newItems: [],
        newItemDuration: 7,
        pagination: {
          rowsPerPage: 5,
        },
        removing: {},
      }
    },
    watch: {
      serviceCredentials(items) {
        items.forEach(function(item) {
          if (this.isNew(item) && !this.newItems.includes(item.RefreshTokenId)) {
            this.newItems.push(item.RefreshTokenId)
            this.delayedClearNewItem(item)
          }
        }.bind(this))
      },
    },
    methods: {
      viewItem(item) {
        this.itemViewed = item
        this.$refs.viewItemDialog.setDialog(true)
      },
      async delayedClearNewItem(item) {
        setTimeout(function() {
          console.log('removeitem')
          console.log(item)
          let index = this.newItems.findIndex(i => i == item.RefreshTokenId)
          if (index != -1) {
            this.newItems.splice(index, 1)
          }
        }.bind(this), this.newItemDuration * 1000)
      },
      isNew(item) {
        let date = moment.utc(item.CreationDateUtc)
        let difference = moment().diff(date, 'seconds') < this.newItemDuration
        console.log(moment().diff(date, 'seconds'))
        return difference
      },
      isRemoving(item) {
        return !!this.removing[item.RefreshTokenId]
      },
      setRemoving(id, value) {
        if (value) {
          this.removing[id] = ''
        } else {
          delete this.removing[id]
        }
      },
      remove(item) {
        this.setRemoving(item.RefreshTokenId, true)
        this.$store.dispatch('servicecredentials/revokeRefreshToken', item)
          .then(() => this.setRemoving(item.RefreshTokenId, false))
          .catch(error => {
            console.log(error)
            this.setRemoving(item.RefreshTokenId, false)
          })
      },
    },
  }
</script>

<style>
  .service-credentials .new {
    background-color: lightskyblue !important;
  }

  .service-credentials .hidden {
    visibility: hidden;
  }

  .service-credentials .item-row {
    -webkit-transition: background-color 1000ms linear;
    -ms-transition: background-color 1000ms linear;
    transition: background-color 1000ms linear;
  }

  .service-credentials-textfield .v-input__append-inner {
    position: absolute;
    right: 12px;
    margin-top: 0px !important;
  }
</style>